import { render, staticRenderFns } from "./advertisingLibrary.vue?vue&type=template&id=c804b684&scoped=true&"
import script from "./advertisingLibrary.vue?vue&type=script&lang=js&"
export * from "./advertisingLibrary.vue?vue&type=script&lang=js&"
import style0 from "./advertisingLibrary.vue?vue&type=style&index=0&id=c804b684&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c804b684",
  null
  
)

export default component.exports